import RewindJob from '../../../../types/api/rewind-job'
import { getShipmentCopies } from './get-shipment-copies'

/** Тираж части; у старых заданий без своего тиража — весь тираж отгрузки. */
export function getRewindJobCopies(rewindJob?: RewindJob): number {
    return rewindJob?.copies ?? getShipmentCopies(rewindJob?.shipment)
}
